import {useGetData} from '../../src/apiservice/apiCall'


export function useGetDepartment(){
	return useGetData('/api/WebApi/GetDepartment')
}